// import { buildImageCarousel } from "./ImageCarousel.builder";
import { ImageCarouselProps } from './ImageCarousel';

export const parseImageCarousel = (data: any): ImageCarouselProps => {
  const images = data.images.map((image: any) => ({
    image: image.desktopImage.gatsbyImageData,
    alt: image.desktopImageAltText || '',
  }));

  return {
    images: images,
  };
};
